import { Heart } from 'lucide-react';

export function DonationsPanel({ donations, donationStats }) {
  return (
    <div className="space-y-6" data-testid="donations-content">
      <div className="flex items-center justify-between">
        <h2 className="font-cabinet text-2xl font-black uppercase tracking-tighter">DONATIONS</h2>
        <div className="flex gap-4">
          <div className="bg-[#141414] border border-[#262626] px-4 py-2 text-center">
            <p className="text-[10px] text-[#A3A3A3] uppercase tracking-wider">Total Received</p>
            <p className="font-mono text-xl font-bold text-[#DAA520]" data-testid="donation-total">${donationStats.total_amount.toFixed(2)}</p>
          </div>
          <div className="bg-[#141414] border border-[#262626] px-4 py-2 text-center">
            <p className="text-[10px] text-[#A3A3A3] uppercase tracking-wider">Donors</p>
            <p className="font-mono text-xl font-bold" data-testid="donation-count">{donationStats.total_count}</p>
          </div>
        </div>
      </div>
      {donations.length === 0 ? (
        <div className="bg-[#141414] border border-[#262626] p-12 text-center">
          <Heart className="w-12 h-12 mx-auto text-[#A3A3A3] mb-4" />
          <p className="text-[#A3A3A3]">No donations yet. The donation section is live on your homepage.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {donations.map((d, i) => (
            <div key={d.id || i} className={`bg-[#141414] border ${d.status === 'paid' ? 'border-[#22C55E]/30' : 'border-[#262626]'} p-4`} data-testid={`donation-${d.id || i}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${d.status === 'paid' ? 'bg-[#DAA520]/10' : 'bg-[#262626]'}`}>
                    <Heart className={`w-5 h-5 ${d.status === 'paid' ? 'text-[#DAA520]' : 'text-[#666]'}`} />
                  </div>
                  <div>
                    <p className="font-bold">{d.name || 'Anonymous'}</p>
                    {d.email && <p className="text-xs text-[#A3A3A3]">{d.email}</p>}
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-mono text-lg font-bold text-[#DAA520]">${d.amount.toFixed(2)}</p>
                  <span className={`text-[10px] font-bold uppercase ${d.status === 'paid' ? 'text-[#22C55E]' : 'text-[#A3A3A3]'}`}>
                    {d.status === 'paid' ? 'COMPLETED' : d.status?.toUpperCase() || 'PENDING'}
                  </span>
                </div>
              </div>
              {d.message && (
                <div className="mt-3 bg-[#0A0A0A] border border-[#262626] p-3 rounded">
                  <p className="text-[10px] text-[#A3A3A3] uppercase mb-1">Message</p>
                  <p className="text-sm text-white italic">&ldquo;{d.message}&rdquo;</p>
                </div>
              )}
              <p className="text-[10px] text-[#666] mt-2">
                {d.created_at ? new Date(d.created_at).toLocaleString() : ''}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
